import { mapGetters, mapMutations } from "vuex";
import StarRating from "vue-star-rating";

export default {
    name: "promo-item",
    props: ["item"],
    computed: {
        ...mapGetters({}),
    },
    components: {
        StarRating,
    },
    methods: {
        ...mapMutations({}),
    },
};
